// eslint-disable-next-line no-unused-vars
import React from "react"
import Navigation from "./navigation"
import Footer from "./footer/footer"

const Layout = ({ children, isDarkMode, langKey = "en" }) => {
  return (
    <div sx={{ overflow: `hidden` }}>
      <Navigation langKey={langKey} isDarkMode={isDarkMode} />
      <main>{children}</main>
      <Footer langKey={langKey} />
    </div>
  )
}

export default Layout
